import React from "react";
import { ChevronDown } from "lucide-react";

import "./Select.css";

const Select = ({
  className = "",
  onChange,
  value,
  defaultValue,
  label,
  items = [],
  defaultOption = "Select",
  required = false,
  disabled = false,
  labelStyle,
  tagline,
  name,
  error,
}) => {
  const isControlled = value !== undefined;

  const handleChange = (event) => {
    onChange?.(event);
  };

  return (
    <div
      className={[
        "select-input",
        disabled && "select-input--disabled",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {label && (
        <label className="select-input__label" style={labelStyle}>
          {label}

          {required && <span className="select-input__required">*</span>}
        </label>
      )}

      {tagline && <span className="select-input__tagline">{tagline}</span>}

      <div className="select-input__control">
        <select
          name={name}
          className="select-input__field"
          value={isControlled ? (value ?? "") : undefined}
          defaultValue={!isControlled ? (defaultValue ?? "") : undefined}
          onChange={handleChange}
          required={required}
          disabled={disabled}
          aria-invalid={Boolean(error)}
        >
          <option value="" disabled={required}>
            {defaultOption}
          </option>

          {items.map((item, index) => (
            <option
              key={item.value ?? index}
              value={item.value}
              disabled={item.disabled}
            >
              {item.label}
            </option>
          ))}
        </select>

        <ChevronDown
          className="select-input__icon"
          size={16}
          aria-hidden="true"
        />
      </div>

      {error && (
        <span className="select-input__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
};

export default Select;
